import type { CandidateDto } from '../candidate.dto';

export type Location = {
  name: string;
  coordinates: { lat: number; lon: number } | undefined;
  commuteTimeByCar: number | undefined;
  commuteTimeByBike: number | undefined;
};

const toCityName = (candidate: CandidateDto): string => {
  const raw = candidate._source.location?.raw?.includes(' null ') ? undefined : candidate._source.location?.raw;
  const shortName = candidate._source.location?.city?.short_name;
  const address = candidate._source.location?.address;

  return raw || shortName || address || '';
};

export const toLocation = (candidate: CandidateDto): Location => {
  const lat = candidate._source.location?.coordinates?.lat;
  const lon = candidate._source.location?.coordinates?.lon;

  return {
    name: toCityName(candidate),
    coordinates: lat && lon ? { lat, lon } : undefined,
    commuteTimeByCar: candidate.distance_to_commute?.driving.duration_minutes,
    commuteTimeByBike: candidate.distance_to_commute?.bike.duration_minutes,
  };
};
